import { render, staticRenderFns } from "./channelCategory.vue?vue&type=template&id=6ba3195a&"
import script from "./channelCategory.vue?vue&type=script&lang=ts&"
export * from "./channelCategory.vue?vue&type=script&lang=ts&"
import style0 from "./channelCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports